<template>
    <a :href="href" @click.stop.prevent="onClick"><slot /></a>
</template>

<script>
import hooks from '@/utils/hooks';
import eventbus from '@/utils/eventbus';

export default {
    props: ['href'],
    methods: {
        onClick(evt) {
            if (!this.href) {
                return;
            }
            let handled = false;

            const data = {
                url: this.href,
            };

            // This is for SPA navigation. We probably never want to keep a modal open aftre navigation
            eventbus.emit('modal.close');

            if (!evt.ctrlKey) {
                handled = hooks.run('navigation', data);
            }
            if (!handled) {
                if (evt.ctrlKey) {
                    window.open(data.url, '_blank');
                } else {
                    window.location = data.url;
                }
            }
            
        },
    },
};
</script>
